import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';
import { LocalStorageModule } from 'angular-2-local-storage';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { MainSharedModule } from './shared/module/mainSharedModule';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OpsLibModule } from 'ops-lib';
import { LoginComponent } from './login/login/login.component';
import { ExternalLoginComponent } from './login/external-login/external-login.component';
import { HeaderBreadcrumbComponent } from './layout/header/header-breadcrumb/header-breadcrumb.component';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { TopComponent } from './layout/top/top.component';
import { AppNavigationComponent } from './layout/app-navigation/app-navigation.component';
import { AppComponent } from './app.component';
import { appReducer } from './shared/store/root.reducer';
import { HeaderComponent } from './layout/header/header.component';
import { NoPrintComponent } from './shared/components/no-print/no-print.component';
import { FooterComponent } from './layout/footer/footer.component';
import { DevLoginComponent } from './login/dev-login/dev-login.component';
import { StagingLoginComponent } from './login/staging-login/staging-login.component';
import { ResponseInterceptor } from './shared/interceptors/response-interceptor';
import { HeaderInterceptor } from './shared/interceptors/header-interceptor';
import { CustomErrorHandler } from './shared/helpers/custom-error-handler.helper';
import { localStorageServiceConfig } from './app.local-storage';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { IntegrationService } from './shared/services/integration.service';
import { EnvironmentLoader } from 'src/environments/utils/environment-loader.util';

export function loadEnvironmentFactory() {
  return () => EnvironmentLoader.loadEnvironment();
}

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    AppNavigationComponent,
    TopComponent,
    HeaderComponent,
    HeaderBreadcrumbComponent,
    NoPrintComponent,
    FooterComponent,
    LoginComponent,
    DevLoginComponent,
    ExternalLoginComponent,
    StagingLoginComponent,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    LocalStorageModule.withConfig(localStorageServiceConfig),
    StoreModule.forRoot(appReducer, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false
      }
    }),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    MainSharedModule,
    OpsLibModule
  ],
  providers: [
    CustomErrorHandler,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: loadEnvironmentFactory, multi: true },
    IntegrationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
